module.exports = __webpack_public_path__ + "static/media/region.ddf1528f.png";